import DashboardLayout from '@/frontend/layouts/DashboardLayout'
import CreationFlow, { type Props } from '@/frontend/pages/Dashboard/DigitalWorkers/new/CreationFlow'
function NewDigitalWorker(props: Props) { return <CreationFlow {...props} /> }
NewDigitalWorker.layout = (page: React.ReactElement) => <DashboardLayout>{page}</DashboardLayout>
export default NewDigitalWorker
